export type ServerFieldError = {
  message: string
  path: ReadonlyArray<string | null>
}

// Backend user-errors carry path ['attributes', '<camelField>']; the terminal
// segment is matched against the form's field names. Everything else lands in
// `orphans` for the caller to surface.
export function mapServerFieldErrors<TFieldName extends string>({
  errors,
  fieldNames,
}: {
  errors: ReadonlyArray<ServerFieldError | null | undefined>
  fieldNames: ReadonlyArray<TFieldName>
}): {
  fields: Partial<Record<TFieldName, { message: string }>>
  orphans: string[]
} {
  const known = new Set<string>(fieldNames)
  const fields: Partial<Record<TFieldName, { message: string }>> = {}
  const orphans: string[] = []
  for (const error of errors) {
    if (!error) continue
    const last = error.path[error.path.length - 1]
    if (last && known.has(last)) {
      fields[last as TFieldName] = { message: error.message }
    } else {
      orphans.push(error.message)
    }
  }
  return { fields, orphans }
}
